import axios from "axios";
import {get_local, set_local} from "../helpers";

export default {
  template: "#vue-flow-page",
  delimiters: ['${', '}'],
  props: ['flow_name'],
  data() {
    return {
      current_step: 'guide-welcome',
      email: '',
      email_status: null,
      customer_id: null,
      breadcrumb: [],
      breadcrumb_titles: {}
    }
  },
  methods: {
    button_handler(action) {
      dataLayer.push({
        event: 'page_flow',
        experience: this.flow_name || 'untitled',
        action: action,
      });

      if (action === '_back') {
        action = this.breadcrumb.length > 1 ? this.breadcrumb[this.breadcrumb.length - 2] : 'guide-welcome'
      }

      if (action.startsWith("/")) {
        window.location = `${window.location.protocol}//${window.location.host}${action}${window.location.search}`
        return
      } else if (action.startsWith("https://") || action.startsWith("http://")) {
        window.location.href = `${action}${window.location.search}`
        return
      }

      if (!(action in this.breadcrumb_titles)) {
        const el = document.getElementById(`c-${action}`)
        if (el) {
          this.breadcrumb_titles[action] = el.value
        } else {
          this.breadcrumb_titles[action] = null
        }
      }
      if (this.breadcrumb_titles[action]) {
        if (this.breadcrumb.includes(action)) {
          this.breadcrumb = this.breadcrumb.slice(0, this.breadcrumb.indexOf(action) + 1)
        } else {
          this.breadcrumb.push(action)
        }
      }
      this.current_step = action
      this.$nextTick(() => {
        const anchor = document.getElementById("flow-anchor")
        if (anchor) {
          anchor.scrollIntoView(true)
        }
      })
    },
    email_form_submit(e, next_action) {
      e.preventDefault();
      this.email_status = 'pending';
      axios.post('/apps/api/web-subscribe', {email: this.email, locale: this.$store.state.lang}).then(
          resp => {
            this.email_status = 'success';
            this.email = '';
            this.customer_id = resp.data.customer_id
            set_local('flow-email-subscribed', '1')
            dataLayer.push({
              event: 'page_flow',
              experience: this.flow_name || 'untitled',
              action: 'email-captured',
            });
            this.button_handler(next_action)
          },
          err => {
            this.email_status = 'error';
          })
    },
    email_form_skip(next_action) {
      dataLayer.push({
        event: 'page_flow',
        experience: this.flow_name || 'untitled',
        action: 'email-opt-out',
      });
      this.button_handler(next_action)
    },
    email_form_existing(next_action) {
      dataLayer.push({
        event: 'page_flow',
        experience: this.flow_name || 'untitled',
        action: 'email-already-given',
      });
      this.button_handler(next_action)
    }
  },
  mounted() {
    this.customer_id = customer_id
    if (get_local('flow-email-subscribed')) {
      this.customer_id = true
    }
    dataLayer.push({
      event: 'page_flow',
      experience: this.flow_name || 'untitled',
      action: 'begin',
    });
  }
}